(function () {
  var code = 'STICK10';
  var storageKey = 'adstavindec_promo_offer_closed_v1';
  var shownKey = 'adstavindec_promo_offer_seen_v1';

  function copyCode(value, button) {
    function markCopied() {
      if (!button) return;
      var original = button.textContent;
      button.textContent = 'Copied';
      window.setTimeout(function () {
        button.textContent = original || value;
      }, 1400);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(value).then(markCopied).catch(markCopied);
    } else {
      markCopied();
    }
  }

  function showOffer() {
    var offer = document.querySelector('[data-ad-promo-offer]');
    if (!offer || offer.classList.contains('is-visible')) return;
    if (window.localStorage.getItem(storageKey) === '1') return;
    offer.classList.add('is-visible');
    window.localStorage.setItem(shownKey, '1');
  }

  function maybeShowByScroll() {
    var doc = document.documentElement;
    var scrollable = doc.scrollHeight - window.innerHeight;
    if (scrollable <= 0) return;
    if (window.scrollY / scrollable >= 0.55) showOffer();
  }

  document.addEventListener('click', function (event) {
    var copyButton = event.target.closest('[data-ad-promo-copy]');
    if (copyButton) {
      copyCode(copyButton.getAttribute('data-ad-promo-copy') || code, copyButton);
      return;
    }

    if (event.target.closest('[data-ad-promo-close]')) {
      var offer = document.querySelector('[data-ad-promo-offer]');
      if (offer) offer.classList.remove('is-visible');
      window.localStorage.setItem(storageKey, '1');
    }
  });

  window.setTimeout(showOffer, 35000);
  window.addEventListener('scroll', maybeShowByScroll, { passive: true });
})();
